import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/store/root.reducer';
import { AuthService } from '../../shared/services/auth.service';
import { AppActions } from '../../shared/store/app.reducer';
import { Subscription } from 'rxjs';
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  currentUserSubscription: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private breadcrumbService: BreadcrumbService,
  ) { }

  ngOnInit() {
    this.authService.clearUserFromLocalStorage();
    this.activatedRoute.queryParams.subscribe(params => {
      const cfid = params['cfid'] || params['CFID'];
      if (cfid) {
        this.authService.login(cfid);
      } else {
        window.location.href = environment.logoutRedirectUrl;
      }
    });
    this.breadcrumbService.setBreadcrumb(this.activatedRoute);
  }

}
